// Services
import { AtlasenseapiService } from './api.service';
import { AuthService } from './auth.service';
import { ConfigurationService } from './config.service';
import { $WebSocket } from './websocket.service';

import { UserService } from './user/user.service';
import { RoleService } from './role/role.service';
import { AppService } from './app/app.service';

export const ATLASENSE_PROVIDERS = [
  AtlasenseapiService,
  ConfigurationService,
  AuthService,
  $WebSocket,
  UserService,
  RoleService,
  AppService
]
